const PANEL_ATTRIBUTES = ["data-track-panel", "data-x-origin"];
const PANEL_SELECTOR = PANEL_ATTRIBUTES.map((attribute) => `[${attribute}]`).join(",");
const SCAN_GAP_MS = 100;

const readName = (element) => {
  for (let index = 0; index < PANEL_ATTRIBUTES.length; index += 1) {
    const value = element.getAttribute(PANEL_ATTRIBUTES[index]);
    if (value && value.trim()) return value.trim();
  }
  return "";
};

const readOpenPanels = () => {
  const names = new Map();
  document.querySelectorAll(PANEL_SELECTOR).forEach((element) => {
    const name = readName(element);
    if (name && !names.has(name)) names.set(name, element.hasAttribute("data-track-panel") ? "panel" : "popup");
  });
  return names;
};

const readAreas = () => {
  const names = new Set();
  document.querySelectorAll("[data-track-workflow]").forEach((element) => {
    const name = (element.getAttribute("data-track-workflow") || "").trim();
    if (name) names.add(name);
  });
  return names;
};

const nextFrame = (callback) => {
  if (typeof requestAnimationFrame === "function") return requestAnimationFrame(callback);
  return Promise.resolve().then(callback);
};

export const watchPanels = (onChange, onAreaGone = () => {}) => {
  if (typeof MutationObserver === "undefined" || typeof document === "undefined" || !document.body) {
    return () => {};
  }

  let open = new Map();
  let areas = new Set();
  let lastScan = 0;
  let waitingSince = 0;
  let stopped = false;

  const scan = () => {
    lastScan = Date.now();
    waitingSince = 0;
    const next = readOpenPanels();
    next.forEach((type, name) => {
      if (!open.has(name)) onChange("open", name, type);
    });
    open.forEach((type, name) => {
      if (!next.has(name)) onChange("close", name, type);
    });
    open = next;
    const nextAreas = readAreas();
    areas.forEach((name) => {
      if (!nextAreas.has(name)) onAreaGone(name);
    });
    areas = nextAreas;
  };

  const run = () => {
    if (stopped) return;
    scan();
  };

  const schedule = () => {
    const at = Date.now();
    if (at - lastScan >= SCAN_GAP_MS) {
      scan();
      return;
    }
    if (waitingSince && at - waitingSince < SCAN_GAP_MS * 5) return;
    waitingSince = at;
    nextFrame(run);
  };

  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [...PANEL_ATTRIBUTES, "data-track-workflow"],
  });
  scan();

  return () => {
    stopped = true;
    observer.disconnect();
  };
};

export default watchPanels;
